import React from 'react';

const Share = () => (
  <svg
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Group compartir@3x</title>
    <defs>
      <path
        d="M22.5860024,8.8817842e-16 C25.7044785,8.8817842e-16 28.232503,2.52802443 28.232503,5.64650059 C28.232503,8.76497676 25.7044785,11.2930012 22.5860024,11.2930012 C21.017382,11.2930012 19.5981563,10.6533663 18.5749204,9.62069164 L11.0818423,13.9928388 C11.2194069,14.4809133 11.2930012,14.9958005 11.2930012,15.5278766 C11.2930012,16.0595883 11.2195077,16.5741346 11.0821249,17.0619115 L18.5788922,21.4310571 C19.6018274,20.4007336 21.0194106,19.7627521 22.5860024,19.7627521 C25.7044785,19.7627521 28.232503,22.2907765 28.232503,25.4092527 C28.232503,28.5277288 25.7044785,31.0557533 22.5860024,31.0557533 C19.4675262,31.0557533 16.9395018,28.5277288 16.9395018,25.4092527 C16.9395018,24.87499 17.0137022,24.3580577 17.1523599,23.8681989 L9.65857493,19.5010659 C8.63526434,20.5343287 7.21562814,21.1743772 5.64650059,21.1743772 C2.52802443,21.1743772 2.22044605e-15,18.6463528 2.22044605e-15,15.5278766 C2.22044605e-15,12.4094005 2.52802443,9.88137604 5.64650059,9.88137604 C7.21562814,9.88137604 8.63526434,10.5214246 9.65857493,11.5546873 L17.1506606,7.1815384 C17.013096,6.69346394 16.9395018,6.1785767 16.9395018,5.64650059 C16.9395018,2.52802443 19.4675262,8.8817842e-16 22.5860024,8.8817842e-16 Z M22.5860024,22.5860024 C21.6073457,22.5860024 20.7449919,23.0839539 20.2384829,23.840315 C20.2169511,23.8904757 20.1919148,23.9399419 20.1636652,23.9884205 C20.1391327,24.0305203 20.1127574,24.070879 20.0847011,24.1094538 L20.0704603,24.1262186 C19.8737216,24.5111781 19.7627521,24.9472562 19.7627521,25.4092527 C19.7627521,26.9684908 21.0267643,28.232503 22.5860024,28.232503 C24.1452405,28.232503 25.4092527,26.9684908 25.4092527,25.4092527 C25.4092527,23.8500146 24.1452405,22.5860024 22.5860024,22.5860024 Z M5.64650059,12.7046263 C4.08726251,12.7046263 2.8232503,13.9686385 2.8232503,15.5278766 C2.8232503,17.0871147 4.08726251,18.3511269 5.64650059,18.3511269 C6.67123911,18.3511269 7.56846428,17.8051774 8.06317786,16.9882765 L8.082954,16.9487088 C8.09126668,16.9344436 8.09979093,16.9203783 8.10852047,16.9065145 C8.33902151,16.5002334 8.46975089,16.0293217 8.46975089,15.5278766 C8.46975089,15.0248048 8.33817193,14.5524648 8.10755125,14.143394 L8.08340741,14.107822 C8.07611634,14.0953282 8.06903881,14.0827687 8.06217371,14.0701476 C7.56976141,13.2513655 6.67197989,12.7046263 5.64650059,12.7046263 Z M22.5860024,2.8232503 C21.0267643,2.8232503 19.7627521,4.08726251 19.7627521,5.64650059 C19.7627521,6.14957245 19.894331,6.6219124 20.1249517,7.03098319 L20.1490956,7.06655526 C20.1565785,7.07937779 20.1638365,7.09226959 20.1708708,7.10522611 C20.6633006,7.92335207 21.5608423,8.46975089 22.5860024,8.46975089 C24.1452405,8.46975089 25.4092527,7.20573868 25.4092527,5.64650059 C25.4092527,4.08726251 24.1452405,2.8232503 22.5860024,2.8232503 Z"
        id="path-2"
      ></path>
    </defs>
    <g
      id="Video-UI-Simple-Playlist-mobile"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="iPhone-11-playlist-mobile-10-reproduccion-stop-video1"
        transform="translate(-362, -196)"
      >
        <g id="Group-compartir" transform="translate(364, 198)">
          <circle
            id="Oval"
            stroke="#FFFFFF"
            strokeWidth="2"
            fillOpacity="0.9"
            fill="#14B395"
            cx="20.0711744"
            cy="19.9288256"
            r="20.9288256"
          ></circle>
          <g id="share-2" transform="translate(2.8233, 4.7526)">
            <mask id="mask-3" fill="white">
              <use xlinkHref="#path-2"></use>
            </mask>
            <use id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-2"></use>
            <g id="COLOR/-black" mask="url(#mask-3)" fill="#FFFFFF">
              <g transform="translate(-2.8233, -1.4116)" id="Rectangle">
                <rect x="0" y="0" width="33.8790036" height="33.8790036"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default Share;
